/**
 * Created by Clayton on 6/21/2017.
 */
import app from '../app';

class RdCarouselController {
    /*@ngInject*/
    constructor($scope) {
        this.$scope = $scope;
    }

    ngOnInit(){
        this.$scope.myInterval = 5000;
        this.$scope.noWrapSlides = true;
        this.$scope.active = 1;
    }
}

app.directive('rdCarousel', () => {

    var directive = {
        restrict: 'E',
        template: require('./carousel.component.html'),
        link: link,
        controller: RdCarouselController,
        controllerAs: 'vm',
        scope: {
            slides: '=',
            hideLinks: '=',
            hideText: '='
        }
    }

    return directive;

    function link(scope, element, attrs) {
        let calculatedWrapperHeight = ($(window).height() - $(".search-container").outerHeight() - $("header").outerHeight());
        $('.rd-carousel-wrapper, .rd-carousel, .carousel-inner, .carousel-inner .item')
            .css('height', calculatedWrapperHeight + 'px')
            .css('min-height', '300px');
        $('.rd-carousel-small .rd-carousel-wrapper').css('height', calculatedWrapperHeight / 1.60 + 'px');
    }

});


// WEBPACK FOOTER //
// ./static/js/app/components/carousel.component.js